const urlPort = process.env.REACT_APP_API_URL_PORT || 3001;

const hostName = window.location.hostname;
const server_url = `http://${hostName}:${urlPort}/`;

async function fetchDataFromApi(endpoint) {
  console.log('Current Hostname:', hostName);
  //console.log("severUrl", server_url);
  try {
    const response = await fetch(server_url + endpoint + '/');
    const jsonData = await response.json();
    return jsonData;
  } catch (error) {
    throw new Error('Error fetching data from API: ' + error.message);
  }
}

export async function postDataToApi(endpoint, postData) {
  try {
    /*const jsonString = JSON.stringify(postData, (key, value) => {
      // Preserve integers as numbers
      if (typeof value === 'number') {
        return value;
      }
      return value.toString(); // Convert other types to strings
    });
    console.log("postData", jsonString);*/
    const response = await fetch(server_url + endpoint + '/', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(postData)
    });
    if (!response.ok) {
      throw new Error('Failed to post data');
    }
    return response;

  } catch (error) {
    console.error('Error posting data:', error);
    return error;
  }
}

export async function putDataToApi(endpoint, postData) {
  try {
    /*const jsonString = JSON.stringify(postData, (key, value) => {
      // Preserve integers as numbers
      if (typeof value === 'number') {
        return value;
      }
      return value.toString(); // Convert other types to strings
    });
    console.log("putData", jsonString,postData);*/
    const response = await fetch(server_url + endpoint + '/', {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(postData)
    });
    if (!response.ok) {
      throw new Error('Failed to post data');
    }
    return response;

  } catch (error) {
    console.error('Error posting data:', error);
    return error;
  }
}


export default fetchDataFromApi;